import { Injectable } from 'framework/di';

@Injectable
export class RecentlyViewedProductService {
  LOCAL_STORAGE_KEY = 'boostSDRecentlyViewedProduct';
  MAX_RECENTLY_VIEWED_PRODUCTS = 10;

  addRecentlyViewedProduct(productId: string | number): void {
    if (!productId) return;

    const productIdString = productId.toString();
    const recentlyViewedProducts = this.getRecentlyViewedProducts();

    const updatedProducts = recentlyViewedProducts.filter(
      (id) => id.toString() !== productIdString
    );

    updatedProducts.unshift(productIdString);

    if (updatedProducts.length > this.MAX_RECENTLY_VIEWED_PRODUCTS) {
      updatedProducts.length = this.MAX_RECENTLY_VIEWED_PRODUCTS;
    }

    try {
      localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(updatedProducts));
    } catch {
      // silently fail if localStorage is unavailable
    }
  }

  clearRecentlyViewedProducts(): void {
    localStorage.removeItem(this.LOCAL_STORAGE_KEY);
  }

  getRecentlyViewedProducts(): string[] {
    try {
      const storedProducts = localStorage.getItem(this.LOCAL_STORAGE_KEY);

      if (!storedProducts) return [];

      const products = JSON.parse(storedProducts);

      if (!Array.isArray(products)) return [];

      return [...new Set(products.filter(Boolean).map((id) => id.toString()))];
    } catch {
      return [];
    }
  }
}
